const LATIN_TARGET_LANGS = ['en', 'de', 'fr', 'es', 'pt', 'it', 'nl', 'pl', 'sv', 'tr']

const LANGUAGE_HINT_WORDS = {
  en: new Set([
    'the', 'a', 'an', 'is', 'are', 'was', 'were', 'be', 'been', 'have', 'has', 'had',
    'do', 'does', 'did', 'will', 'would', 'can', 'could', 'should', 'may', 'might', 'must',
    'i', 'you', 'he', 'she', 'it', 'we', 'they', 'this', 'that', 'these', 'those',
    'my', 'your', 'our', 'their', 'what', 'which', 'who', 'when', 'where', 'why', 'how',
    'and', 'or', 'but', 'if', 'then', 'not', 'no', 'yes', 'all', 'some', 'any', 'each', 'every',
    'hello', 'hi', 'hey', 'thanks', 'thank', 'please', 'good', 'morning', 'afternoon', 'evening',
    'day', 'night', 'ok', 'okay', 'dear', 'with', 'from', 'for', 'to', 'of', 'in', 'on', 'at', 'by',
    'about', 'as', 'into', 'through', 'after', 'before', 'between', 'under', 'over', 'again',
    'here', 'there', 'both', 'few', 'more', 'most', 'other', 'such', 'only', 'own', 'same', 'so',
    'than', 'too', 'very', 'just', 'also', 'now', 'well', 'really', 'sure', 'great', 'nice',
    'welcome', 'sorry', 'world',
  ]),
  de: new Set([
    'der', 'die', 'das', 'den', 'dem', 'des', 'ein', 'eine', 'einer', 'einem', 'einen',
    'und', 'ist', 'sind', 'war', 'waren', 'ich', 'du', 'er', 'sie', 'es', 'wir', 'ihr',
    'nicht', 'mit', 'von', 'zu', 'auf', 'für', 'fur', 'auch', 'aber', 'oder', 'wenn', 'dass',
    'guten', 'gute', 'tag', 'tage', 'morgen', 'abend', 'hallo', 'danke', 'bitte', 'ja', 'nein',
    'wie', 'was', 'wer', 'wo', 'wann', 'warum', 'schön', 'schon', 'gut', 'sehr', 'hier', 'dort',
  ]),
  fr: new Set([
    'le', 'la', 'les', 'un', 'une', 'des', 'de', 'du', 'et', 'est', 'sont', 'été', 'ete',
    'je', 'tu', 'il', 'elle', 'nous', 'vous', 'ils', 'elles', 'pas', 'ne', 'avec', 'pour',
    'dans', 'sur', 'bonjour', 'bonsoir', 'merci', 'oui', 'non', 'très', 'tres', 'bien',
    'comment', 'quoi', 'qui', 'où', 'ou', 'quand', 'pourquoi', 'bonne', 'bon', 'jour',
  ]),
  es: new Set([
    'el', 'la', 'los', 'las', 'un', 'una', 'y', 'es', 'son', 'fue', 'fueron', 'yo', 'tú', 'tu',
    'él', 'ella', 'nosotros', 'vosotros', 'ellos', 'ellas', 'no', 'sí', 'si', 'con', 'para',
    'por', 'de', 'en', 'hola', 'gracias', 'buenos', 'buenas', 'días', 'dias', 'tarde', 'noche',
    'muy', 'bien', 'cómo', 'como', 'qué', 'que', 'quién', 'quien',
  ]),
  pt: new Set([
    'o', 'a', 'os', 'as', 'um', 'uma', 'e', 'é', 'são', 'sao', 'eu', 'você', 'voce', 'ele',
    'ela', 'nós', 'nos', 'com', 'para', 'por', 'de', 'em', 'não', 'nao', 'sim', 'olá', 'ola',
    'obrigado', 'obrigada', 'bom', 'boa', 'dia', 'tarde', 'noite', 'muito', 'bem',
  ]),
  it: new Set([
    'il', 'lo', 'la', 'i', 'gli', 'le', 'un', 'una', 'e', 'è', 'sono', 'io', 'tu', 'lui', 'lei',
    'noi', 'voi', 'loro', 'non', 'con', 'per', 'di', 'in', 'su', 'ciao', 'grazie', 'buongiorno',
    'buonasera', 'buona', 'buon', 'giorno', 'sera', 'notte', 'molto', 'bene', 'sì', 'si',
  ]),
  nl: new Set([
    'de', 'het', 'een', 'en', 'is', 'zijn', 'was', 'waren', 'ik', 'jij', 'hij', 'zij', 'wij',
    'jullie', 'niet', 'met', 'van', 'voor', 'in', 'op', 'aan', 'hallo', 'dag', 'goedemorgen',
    'goedenavond', 'dank', 'bedankt', 'ja', 'nee', 'hoe', 'wat', 'wie', 'waar', 'wanneer',
  ]),
  pl: new Set([
    'i', 'w', 'z', 'na', 'do', 'to', 'jest', 'są', 'sa', 'nie', 'tak', 'cześć', 'czesc',
    'dzień', 'dzien', 'dobry', 'dziękuję', 'dziekuje', 'proszę', 'prosze', 'dobranoc',
  ]),
  sv: new Set([
    'och', 'att', 'det', 'som', 'är', 'ar', 'inte', 'jag', 'du', 'han', 'hon', 'vi', 'ni',
    'med', 'för', 'for', 'på', 'pa', 'till', 'från', 'fran', 'hej', 'god', 'morgon', 'kväll',
    'kvall', 'tack', 'ja', 'nej',
  ]),
  tr: new Set([
    've', 'bir', 'bu', 'şu', 'su', 'o', 'de', 'da', 'için', 'icin', 'ile', 'ben', 'sen', 'biz',
    'siz', 'onlar', 'değil', 'degil', 'evet', 'hayır', 'hayir', 'merhaba', 'günaydın', 'gunaydin',
    'teşekkürler', 'tesekkurler', 'lütfen', 'lutfen', 'iyi', 'gün', 'gun',
  ]),
}

function normalizeLangCode(lang) {
  const lower = String(lang || 'en').trim().toLowerCase()
  if (!lower) return 'en'
  if (lower === 'zh-cn') return 'zh'
  if (lower === 'zh-tw') return 'zh-tw'
  return lower.split('-')[0]
}

function tokenizeLatinWords(text) {
  return (String(text || '').toLowerCase().match(/[a-zàáâãäåæçèéêëìíîïñòóôõöùúûüýÿœß]+/g) || [])
}

function hasTargetLanguageHints(text, lang) {
  const code = normalizeLangCode(lang)
  const hints = LANGUAGE_HINT_WORDS[code]
  if (!hints) return false
  const tokens = tokenizeLatinWords(text)
  if (!tokens.length) return false
  const matches = tokens.filter((token) => hints.has(token)).length
  if (tokens.length <= 4) return matches >= 1
  return matches >= 2 || matches / tokens.length >= 0.12
}

/** Skip API call when the message is likely already in the target language. */
export function likelyAlreadyInTargetLanguage(text, lang) {
  const t = String(text || '')
  if (!t.trim()) return false

  const cjk = (t.match(/[\u4e00-\u9fff]/g) || []).length
  const latin = (t.match(/[a-zA-ZÀ-ÖØ-öø-ÿ]/g) || []).length
  const kana = (t.match(/[\u3040-\u30ff]/g) || []).length
  const hangul = (t.match(/[\uac00-\ud7af]/g) || []).length
  const letters = cjk + latin + kana + hangul
  if (!letters) return false

  const code = normalizeLangCode(lang)

  if (code === 'zh' || code === 'zh-tw') {
    return cjk / letters > 0.25
  }
  if (code === 'ja') {
    return (kana + cjk * 0.5) / letters > 0.15
  }
  if (code === 'ko') {
    return hangul / letters > 0.15
  }
  if (LATIN_TARGET_LANGS.includes(code)) {
    if (cjk / letters > 0.05) return false
    if (latin / letters < 0.5) return false
    return hasTargetLanguageHints(t, code)
  }
  return false
}
